// @flow
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import AppPreferencesActions from 'common/redux/actions/appPreferences';
import { getShouldIncludeInactiveTeams } from 'common/redux/selectors/appPreferences';

const useShouldIncludeInactiveTeams = (): [
    boolean,
    (value: boolean) => void
] => {
    const shouldIncludeInactiveTeams = useSelector(
        getShouldIncludeInactiveTeams
    );

    const dispatch = useDispatch();
    const setShouldIncludeInactiveTeams = useCallback(
        isChecked =>
            dispatch(
                AppPreferencesActions.setShouldIncludeInactiveTeams(isChecked)
            ),
        [dispatch]
    );

    return [shouldIncludeInactiveTeams, setShouldIncludeInactiveTeams];
};

export default useShouldIncludeInactiveTeams;
